import slugify from 'slugify';
import { slugifySku } from './formats';
import { getArticlePath } from './getArticlePath.js';

export const LinkShape = {};

export const getBlogCategoryPath = (slug: string): string =>
  getArticlePath(slug);

export const getCollectionLink = (title: string) => {
  const newSlug = title
    ?.split('/')
    .map((level: string) =>
      slugify(level, { lower: true, strict: true, trim: true })
    )
    .join('/');

  const pathname = `/shop/${newSlug}`;

  if (pathname.includes('all-products')) {
    return pathname.replace('/all-products', '');
  }
  return pathname;
};

export type GetLinkInternalLink = Parameters<typeof getLink>[2];

export const getLink = (
  type: string,
  href: string,
  internalLink: {
    slug?: { current?: string };
    _type?: string;
    siteIdentifier?: string;
    store?: {
      variants?: { sku?: string; store?: { sku?: string } }[];
      title?: string;
      slug?: { current?: string };
    };
  }
) => {
  if (type === 'external') {
    return href;
  }
  if (type === 'internal') {
    try {
      switch (internalLink?._type) {
        case 'page':
          if (internalLink?.slug?.current === '/homepage') {
            return `/`;
          }
          return `/${internalLink.slug.current}`;
        case 'globalProduct':
        case 'product':
          if (
            process.env.GATSBY_SHOPIFY_SHOP_NAME.includes('petsafe') ||
            process.env.GATSBY_SHOPIFY_SHOP_NAME.includes('sportdog')
          ) {
            const sku =
              internalLink?.store?.variants?.[0]?.sku ||
              internalLink?.store?.variants?.[0]?.store?.sku ||
              '';
            return `/p/${internalLink.store.slug.current}${
              sku ? `/${slugifySku(sku)}` : ''
            }`;
          }
          return `/product/${internalLink.store.slug.current}`;
        case 'pressRelease':
          return `/press/${internalLink.slug.current}`;
        case 'blogPost':
        case 'blogCategory':
          if (process.env.GATSBY_SHOPIFY_SHOP_NAME.includes('sportdog')) {
            return `/hunting-training-tips/${internalLink.slug.current}`;
          } else if (
            process.env.GATSBY_SHOPIFY_SHOP_NAME.includes('invisible-fence')
          ) {
            return getArticlePath(internalLink.slug.current);
          }
          return `/blog/${internalLink.slug.current}`;

        case 'globalProductCollection':
        case 'collection':
          return getCollectionLink(internalLink?.store?.title);

        default:
          return `/${internalLink?.slug?.current}`;
      }
    } catch (e) {
      console.error('Get internal link error', e);
      return undefined;
    }
  }
  return undefined;
};

export default getLink;
